"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var counto_directive_1 = require("./src/counto.directive");
exports.CountoDirective = counto_directive_1.CountoDirective;
var counto_module_1 = require("./src/counto.module");
exports.CountoModule = counto_module_1.CountoModule;
exports.default = counto_module_1.CountoModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-counto/index.js
// module id = 1060
// module chunks = 20